enum StatusCodes {
  OK = 200,
  UNAUTHORIZED = 401
}

export default StatusCodes
